<template>
  <div class="modal-card payment-warning-modal">
    <img v-if="status !== 'locked' || isDashQuillAdmin" src="/icons/close.png" alt="Close Modal" class="close-modal-icon" @click="$emit('closeModal')" />

    <div class="warning-icon-container" :class="{ locked: status === 'locked' }">
      <vue-feather :type="status === 'locked' ? 'lock' : 'alert-triangle'" size="32" />
    </div>

    <div class="modal-card-header">
      <h1 class="title">{{ status === 'locked' ? 'Account Terminated' : 'Payment Issue' }}</h1>
      <p class="subtitle" v-html="message"></p>
    </div>

    <div v-if="isAdmin" class="modal-card-footer">
      <BaseButton label="Go to Billing Settings" variant="primary" block @click="$emit('goToBilling')" />
    </div>
  </div>
</template>

<script>
import { BaseButton } from '@/design'
import VueFeather from 'vue-feather'

export default {
  name: 'PaymentWarningModal',
  components: { BaseButton, 'vue-feather': VueFeather },
  props: {
    status: { type: String, required: true },
    isAdmin: { type: Boolean, default: false },
    isDashQuillAdmin: { type: Boolean, default: false },
    daysRemaining: { type: Number, default: null }
  },
  emits: ['closeModal', 'goToBilling'],
  computed: {
    message() {
      if (this.status === 'locked') {
        return this.isAdmin
          ? 'Your account has been terminated due to non-payment. Please update your payment method to restore access.'
          : 'Your account has been terminated due to non-payment. Please ask your clinic administrator to update the payment method to restore access.'
      }
      const countdown = this.daysRemaining != null
        ? ` Your account will be terminated in <span class="days-highlight">${this.daysRemaining} day${this.daysRemaining !== 1 ? 's' : ''}</span>.`
        : ''
      return this.isAdmin
        ? `Your subscription payment has failed. Please update your payment method to avoid service interruption.${countdown}`
        : `A subscription payment has failed. Please contact your clinic administrator to update the payment method to prevent service disruption.${countdown}`
    }
  }
}
</script>

<style scoped>
.payment-warning-modal {
  max-width: 480px;
}

.warning-icon-container {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: #FEF3C7;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
  color: #D97706;
}

.warning-icon-container.locked {
  background: #FEE2E2;
  color: #DC2626;
}

.modal-card-header {
  margin-bottom: 0;
}

.title {
  margin-bottom: 8px;
}

.subtitle {
  line-height: 1.5;
}

.subtitle :deep(.days-highlight) {
  font-weight: 700;
  color: #6a16f0;
}

.modal-card-footer {
  margin-top: 28px;
}
</style>
